import axios from 'axios';

const API_URL = `${process.env.VUE_APP_HOST}/api/reports`;

let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
  access_token = process.env.VUE_APP_TOKEN;
  if (!access_token) {
    console.log(window.location.hash)
    var queries = window.location.hash.split("access_token=")
    if (queries.length > 1) {
      access_token = queries[1].split("&")[0]
      if (access_token) {
        let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
        localStorage.setItem('session-authorization', auth);
      }
    }
  }
}
else {
  access_token = JSON.parse(auth).access_token;
}

let headers = {
  headers: {
    'Authorization': `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  }
};


export const reportsApi = {
  getModuleStaffReport: async (filters) => {
    const response = await axios.get(`${API_URL}/module-staff`, {
      params: filters, headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  getModuleStaffNoActReport: async (filters) => {
    const response = await axios.get(`${API_URL}/module-staff/NoAct`, {
      params: filters, headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  exportModuleStaffReport: async (filters) => {
    const response = await axios.get(`${API_URL}/module-staff/export`, {
      params: filters,
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  exportModuleStaffNoActReport: async (filters) => {
    const response = await axios.get(`${API_URL}/module-staff/NoAct/export`, {
      params: filters,
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  exportCompletedStudentReport: async (id) => {
    const response = await axios.get(`${API_URL}/ExportCompletedStudentList?id=`+id, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  compareSitsPlus: async () => {
    const response = await axios.get(`${API_URL}/CompareModule`, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
  exportSurveyListReport: async (id, type) => {
    const response = await axios.get(`${API_URL}/Survey/${id}/StudentList/export?type=${type}`, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

};
